import Icon from '../icon/Icon';

import styles from '../../styles/modules/layout/App.module.scss';

import useSound from '../../hooks/useSound';

import AuthButtons from '../auth/AuthButtons';

import { useConfigStore } from '../../store/useConfigStore';

import Modal from '../modal/Modal';

import logoImg from '../../assets/images/logo.webp';

const Header = () => {
	const { muted, toggle } = useSound();

	const { openModal } = useConfigStore((s) => s);

	const openModalHandler = () => {
		openModal(Modal);
	};

	return (
		<div className={styles.header}>
			<div className={styles.logo} onClick={openModalHandler}>
				<img src={logoImg} alt='EPICDROP' />
			</div>

			<div onClick={openModalHandler} className={styles.auth}>
				<AuthButtons
					text='войти'
					className={styles.authButtons}
					classNameButton={styles.authButton}
					classNameTitle={styles.authButtonsTitle}
				/>
			</div>

			<div className={styles.sound} onClick={toggle}>
				<Icon name={muted ? 'sound' : 'sound-off'} />
			</div>
		</div>
	);
};

export default Header;
